import { PermissionGroupId } from 'PermissionGroups/Types';
import EventEmitterWithUnsubscribeCallback, { UnsubscribeCallback } from './EventHandler';
import { SessionInfo } from 'SessionInfo/Types';
import { DigifiProduct } from 'components/RouteWithPermissions/Types';

export enum AuthEventMessage {
  SessionInfoUpdate = 'authEvents/sessionInfoUpdate',
  UnauthorizedRequest = 'authEvents/unauthorizedRequest',
  Logout = 'authEvents/logout',
  SelectOrganization = 'authEvents/selectOrganization',
}

export interface UserInfoHeader {
  isMfaIncomplete?: true;
  isActive: boolean;
  isEmailVerified: boolean;
  permissionGroupId: PermissionGroupId;
  permissionGroupName: string;
  isOwner: boolean;
}

export enum OrganizationSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export interface OrganizationInfoHeader {
  id: string;
  subscriptionStatus: OrganizationSubscriptionStatus;
}

export type MinifiedSubscription = Record<DigifiProduct, 1 | 0>;

type Callback<Param> = (params: Param) => void;

export type PendingOperation = Promise<unknown>;

export interface AuthEventEmitterType {
  on(message: AuthEventMessage.SessionInfoUpdate, callback: Callback<Partial<SessionInfo>>): UnsubscribeCallback;
  on(message: AuthEventMessage.UnauthorizedRequest, callback: () => void): UnsubscribeCallback;
  on(message: AuthEventMessage.Logout, callback: () => void): UnsubscribeCallback;
  on(
    message: AuthEventMessage.SelectOrganization,
    callback: (operation: PendingOperation) => void,
  ): UnsubscribeCallback;

  emit(message: AuthEventMessage.SessionInfoUpdate, userInfo: Partial<SessionInfo>): void;
  emit(message: AuthEventMessage.UnauthorizedRequest): void;
  emit(message: AuthEventMessage.Logout): void;
  emit(message: AuthEventMessage.SelectOrganization, operation: PendingOperation): void;
}

const AuthEventEmitter: AuthEventEmitterType = new EventEmitterWithUnsubscribeCallback();

export default AuthEventEmitter;
